// Copies the host's current filter view as a shareable URL (see
// `composeShareUrl` in functions/index.js). Label toggles to "Copied!"
// for 2s after a successful write (driven by `host.linkCopyFlash`
// which `copyLinkToClipboard` sets/resets).

export const MarketplaceCopyLinkBtn = {
  extends: 'Button',
  text: (el) => {
    const host = el.call('marketplaceHostOf', el)
    return host?.linkCopyFlash ? 'Copied!' : 'Copy link'
  },
  fontSize: 'Y',
  padding: 'X A',
  // `title` attr native tooltip — see CardThumbBadge / DetailKindTag for
  // the same pattern; no `attr: {}` wrapper needed (CLAUDE.md HTML attr
  // rule).
  title: 'Copy a link that reproduces this filtered view',
  onClick: (e, el) => {
    const host = el.call('marketplaceHostOf', el)
    el.call('copyLinkToClipboard', host)
  }
}
